import Flex from 'typescript-styled-flex'
import styled from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const SearchWrapper = styled(Flex as any)<IWithSize>`
  padding-top: ${({ size }) => (size ? 12 * size : 12)}px;
  align-items: center;
`

export default SearchWrapper
